import { TProductType, TStatusMessages } from 'typings';

export const CURRENCY: TStatusMessages = {
  USD: '$',
  EUR: '€',
  GBP: '£'
};

export const PRODUCT_NAME = 'InstaVision';

export const SUBSCRIBE_STATUS = {
  Active: 'Active',
  Cancelled: 'Cancelled'
};

export const PRODUCT_TYPE = {
  HOME_SECURITY: 'HomeSecurity',
  BIRD: 'Bird',
  PET: 'Pet',
  TRAIL: 'Trail',
  BABY: 'Baby'
};

export const DEFAULT_PRODUCT_TYPE = PRODUCT_TYPE.HOME_SECURITY as TProductType;
export const MAX_BIRD_CAMERA_LIMIT = 1;

export enum PartnerName {
  INSTAVIEW = 'instaview',
  HOMIQ = 'homiq',
  LUNA = 'luna',
  HALOVUE = 'halovue',
  WAISCEN = 'waiscen',
  NEWAIEYE = 'newaieye',
  IV_SANDBOX = 'iv_sandbox'
}
